import { useTranslation } from 'react-i18next'
import { useCustomer } from 'hooks/useSession'
import TextPaper from '@ui/elements/TextPaper'
import { useConfirmCustomer } from '@user/customer/confirmation/useConfirmCustomer'
import { hasTextPaperLines } from '@user/customer/confirmation/getTextPaperStatus'

interface Props {
  onPress: () => void
}

export default function ContactDetails({ onPress }: Props) {
  const { t } = useTranslation(['ui', 'modals'])

  const customer = useCustomer()
  const { needsContact, getDetailStatus } = useConfirmCustomer()
  const { email, mobile, phone } = customer || {}

  const lines = [email, mobile, phone]
  const status = getDetailStatus({
    hasData: hasTextPaperLines(lines),
    isValid: !needsContact,
    section: 'contact',
  })

  return (
    <TextPaper
      onPress={onPress}
      icon="message-circle-2"
      label={t('modals:contact.title')}
      lines={lines}
      status={status}
    />
  )
}
